/* TikTok-Landingpage "Lotta & Paul": Einblend-Animationen, Namens-Wechsel im Titel, Mini-Video, Video-Fenster. ES5. Claude, 23.10.2026 */
(function () {
  "use strict";
  var root = document.querySelector(".ptt");
  if (!root) return;
  var d = document, w = window;
  function addCls(el, c) { if (el && (" " + el.className + " ").indexOf(" " + c + " ") < 0) el.className += " " + c; }
  function rmCls(el, c) { if (el) el.className = (" " + el.className + " ").replace(" " + c + " ", " ").replace(/^\s+|\s+$/g, ""); }
  function on(el, ev, fn) { if (el && el.addEventListener) el.addEventListener(ev, fn, false); }
  function track(name, data) { try { if (w.PTNeuTrack) w.PTNeuTrack(name, data); if (w.dataLayer && w.dataLayer.push) w.dataLayer.push({ event: name, pt_landing: "tiktok-lotta-paul-1", detail: data || {} }); } catch (e) {} }
  var reduce = false;
  try { reduce = !!(w.matchMedia && w.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) {}
  addCls(root, "ptt-js");

  /* ---- Einblenden beim Scrollen ---- */
  var rev = root.querySelectorAll("[data-ptt-reveal],[data-ptt-inview]");
  function showAll() { for (var i = 0; i < rev.length; i++) addCls(rev[i], "is-in"); }
  if (reduce || !("IntersectionObserver" in w)) showAll();
  else {
    var io = new w.IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) if (en[i].isIntersecting) { addCls(en[i].target, "is-in"); io.unobserve(en[i].target); }
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });
    for (var r = 0; r < rev.length; r++) io.observe(rev[r]);
    /* Sicherheitsnetz: nach 6 s alles sichtbar, falls ein Observer haengt */
    w.setTimeout(function () { for (var i = 0; i < rev.length; i++) if (rev[i].getBoundingClientRect().top < (w.innerHeight || 800)) addCls(rev[i], "is-in"); }, 6000);
  }

  /* ---- Titel: "Wer ist dein Paul?" – Namen wechseln, bis jemand tippt ---- */
  var nameEl = root.querySelector("[data-ptt-name]");
  var titleEl = root.querySelector("[data-ptt-title]");
  var names = [["dein", "Paul"], ["deine", "Oma"], ["dein", "Schatz"], ["deine", "Lisa"], ["dein", "Papa"], ["deine", "beste Freundin"], ["dein", "Paul"]];
  var ni = 0, timer = null, typed = false;
  function setTitle(art, nm) {
    if (!titleEl || !nameEl) return;
    titleEl.firstChild.nodeValue = "Wer ist " + art + " ";
    nameEl.textContent = nm;
    if (!reduce) { rmCls(nameEl, "is-flip"); void nameEl.offsetWidth; addCls(nameEl, "is-flip"); }
  }
  function cycle() {
    if (typed) return;
    ni = (ni + 1) % names.length;
    setTitle(names[ni][0], names[ni][1]);
    timer = w.setTimeout(cycle, ni === names.length - 1 ? 3800 : 1700);
  }
  if (titleEl && nameEl && titleEl.firstChild && titleEl.firstChild.nodeType === 3 && !reduce) timer = w.setTimeout(cycle, 2600);
  var rec = root.querySelector('[data-ptn-livefield="recipient"]');
  var snd = root.querySelector('[data-ptn-livefield="sender"]');
  function onType() {
    if (!typed) { typed = true; if (timer) w.clearTimeout(timer); track("ptt_type", {}); }
    var v = rec && rec.value ? String(rec.value).replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "") : "";
    if (!titleEl || !nameEl) return;
    if (v) { titleEl.firstChild.nodeValue = "Ein Baum für "; nameEl.textContent = v.length > 22 ? v.slice(0, 21) + "…" : v; titleEl.lastChild.nodeValue = "."; }
    else { titleEl.firstChild.nodeValue = "Wer ist dein "; nameEl.textContent = "Paul"; titleEl.lastChild.nodeValue = "?"; }
  }
  on(rec, "input", onType); on(snd, "input", function () { if (!typed) { typed = true; if (timer) w.clearTimeout(timer); } });

  /* ---- Mini-Video im Kopf: stumm abspielen, wenn sichtbar ---- */
  var mini = root.querySelector("[data-ptt-mini]");
  function miniPlay() {
    if (!mini || reduce) return;
    try { mini.muted = true; var p = mini.play(); if (p && p["catch"]) p["catch"](function () {}); } catch (e) {}
  }
  if (mini && !reduce) {
    var saveData = false;
    try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
    if (!saveData) w.setTimeout(function () { mini.preload = "auto"; miniPlay(); }, 1200);
  }

  /* ---- Video-Fenster mit Ton ---- */
  var lb = d.querySelector("[data-ptt-lb]");
  var big = lb ? lb.querySelector("[data-ptt-big]") : null;
  var lastFocus = null;
  function openLb(src) {
    if (!lb || !big) return;
    lastFocus = d.activeElement;
    lb.removeAttribute("hidden");
    try { d.documentElement.style.overflow = "hidden"; } catch (e) {}
    try { big.currentTime = 0; big.muted = false; var p = big.play(); if (p && p["catch"]) p["catch"](function () {}); } catch (e) {}
    var x = lb.querySelector("[data-ptt-close]"); if (x && x.focus) x.focus();
    track("ptt_video_open", { source: src || "" });
  }
  function closeLb() {
    if (!lb || lb.hasAttribute("hidden")) return;
    try { big.pause(); } catch (e) {}
    lb.setAttribute("hidden", "");
    try { d.documentElement.style.overflow = ""; } catch (e) {}
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  on(d, "click", function (e) {
    var t = e.target;
    while (t && t !== d && t.nodeType === 1) {
      if (t.hasAttribute("data-ptt-play")) { e.preventDefault(); openLb(t.getAttribute("data-ptt-play")); return; }
      if (t.hasAttribute("data-ptt-close")) { e.preventDefault(); closeLb(); return; }
      if (t === lb) { closeLb(); return; }
      t = t.parentNode;
    }
  });
  /* Klick auf "Gestalten" im Video-Fenster: Fenster schliessen. Capture auf window, weil pt-neu.js
     diese Klicks selbst in der Capture-Phase abfaengt (dieses Skript laedt vorher, laeuft also zuerst). */
  if (w.addEventListener) w.addEventListener("click", function (e) {
    var t = e.target;
    while (t && t !== d && t.nodeType === 1) { if (t.hasAttribute("data-ptn-open")) { if (lb && lb.contains(t)) closeLb(); return; } t = t.parentNode; }
  }, true);
  on(d, "keydown", function (e) { if ((e.keyCode || e.which) === 27) closeLb(); });
  if (big) on(big, "ended", function () { track("ptt_video_end", {}); });

  /* ---- Herkunft fuer Auswertung: Landingpage-Besuch ---- */
  track("ptt_view", { ref: (d.referrer || "").split("/")[2] || "" });
})();
